<template>

    <div class="vx-row">
        <div class="vx-col w-2/3">
            <vs-card>
                <vs-input v-model="name" class="w-full" placeholder="Naam"></vs-input>
            </vs-card>
            <vs-card class="mb-4">
                <div slot="header">
                    <h5>Prijs</h5>
                </div>
                <div>
                    <vs-input icon="euro" v-model="price" class="w-full" placeholder="Prijs"></vs-input>
                </div>
            </vs-card>
        </div>
        <div class="vx-col w-1/3">
            <vs-button @click="createProduct" class="w-full mb-6">Opslaan</vs-button>
            <vs-card>
                <div slot="header">
                    <h5>Categorie</h5>
                </div>
                <div>
                    <vs-radio v-for="cat in categories" :key="cat.id" class="w-full" :vs-value="cat" v-model="category">{{ cat.name }}</vs-radio>
                </div>
            </vs-card>
        </div>
    </div>

</template>

<script>
export default {
    data() {
        return {
            position: '',
            name: '',
            price: '',
            category: null,
            categories: []
        }
    },
    created() {
        this.getProductAddonCategories();
    },
    computed: {
        staffRoute () {
            if(this.$route.meta.staff) {
                if(localStorage.getItem('stafftoken') !== null) {
                    return true
                }
            } else {
                if(localStorage.getItem('stafftoken') !== null) {
                    return true
                }
                return false
            }
        },
    },
    methods: {
        handleImageUpload: function() {
            this.image = this.$refs.image.files[0];
        },
        getProductAddonCategories: function() {
            let url = this.staffRoute ? '/v1/company/'+ this.$route.params.slug +'/product-category-addons' : 'v1/company/'+ this.$route.params.slug +'/product-category-addons'
            this.$http.get(url).then((response) => {
                this.categories = response.data;
            }).catch((error) => {
                this.$util.logError(error, this.$vs);
            });
        },
        createProduct: function() {
            let formData = new FormData();

            formData.append('name', this.name);
            formData.append('position', this.position);
            formData.append('price', this.price);
            formData.append('company_product_addon_category_id', this.category.id);

            let url = this.staffRoute ? '/v1/company/'+ this.$route.params.slug +'/product-addon/create' : '/v1/company/'+ this.$route.params.slug +'/product-addon/create'
            this.$http.post(url, formData).then((response) => {
                console.log(response)
                this.$router.push({'name': 'companies-products-options'});
                this.$vs.notify({
                    title: 'Success',
                    text: 'Succesvol opgeslagen',
                    color: 'success'
                });
            }).catch((error) => {
                this.$util.logError(error, this.$vs);
            })
        }
    }
}
</script>

<style>

</style>
